import {

  CANDIDATE_ACTION_TYPE,

  type IAccountCondensed,

  type IAccountEnrichment,

  type ICandidateAction,

} from "../Types/account";

import {

  TUTORIAL_AMC_CLIENT_ID,

  TUTORIAL_DEMO_HERO_ACTION,

  TUTORIAL_DEMO_PORTFOLIO,

  TUTORIAL_SCENARIO,

} from "./tutorialScenario";



/** Stable prefix for legacy demo ids (unused when real action ids are wired). */

export const TUTORIAL_DEMO_ACCOUNT_ID_PREFIX = "tutorial-demo-acct-";

export const TUTORIAL_DEMO_ACTION_ID_PREFIX = "tutorial-demo-action-";



export const TUTORIAL_DEMO_CLIENT_ID = TUTORIAL_AMC_CLIENT_ID;



/** Numeric id used in `/account/:id` during the App Guide (Zayo). */

export const TUTORIAL_DEMO_ACCOUNT_NUMERIC_ID = TUTORIAL_DEMO_PORTFOLIO[0].id;



/** Real AMC action ids shown on the hotlist during the tour. */

export const TUTORIAL_DEMO_ACTION_IDS = [

  TUTORIAL_DEMO_HERO_ACTION.action_id,

  "K5jJJupVe8j2U50p",

  "7LUQoX0h5fFqRsYo",

] as const;



export type TutorialDemoAccountView =
  | "overview"
  | "insights"
  | "insightsTable"
  | "contacts"
  | "calendar";

export function getTutorialDemoAccountPath(
  view: TutorialDemoAccountView = "overview",
): string {
  const base = `/account/${TUTORIAL_DEMO_ACCOUNT_NUMERIC_ID}`;
  switch (view) {
    case "contacts":
      return `${base}?tab=insights&workspace=contacts`;
    case "calendar":
      return `${base}?tab=calendar`;
    case "insightsTable":
      return `${base}?tab=insights&insightsView=table`;
    case "insights":
    case "overview":
    default:
      // Match production: insights tab defaults to Signals when available.
      return `${base}?tab=insights`;
  }
}



export const TUTORIAL_DEMO_ACCOUNT_ENRICHMENTS: IAccountEnrichment[] =

  TUTORIAL_DEMO_PORTFOLIO.map((account) => ({

    id: account.uuid,

    name: account.name,

    domain: account.domain.startsWith("http")

      ? account.domain

      : `https://${account.domain}`,

    industry: account.industry,

    logo_image_url: account.logo_image_url,

  }));



export function isTutorialDemoActionId(actionId: string): boolean {

  return (

    actionId.startsWith(TUTORIAL_DEMO_ACTION_ID_PREFIX) ||

    (TUTORIAL_DEMO_ACTION_IDS as readonly string[]).includes(actionId)

  );

}



/** Only the primary tour account (Zayo) uses the demo workspace shell. */

export function isTutorialDemoAccountId(accountId: number | string): boolean {

  return String(accountId) === String(TUTORIAL_DEMO_ACCOUNT_NUMERIC_ID);

}



export function buildTutorialDemoActions(suggestedDate: string): ICandidateAction[] {

  const at = `${suggestedDate}T12:00:00.000Z`;

  const hero = TUTORIAL_DEMO_HERO_ACTION;



  return [

    {

      action_id: hero.action_id,

      action_type: CANDIDATE_ACTION_TYPE.INSIGHT_EMAIL,

      account_id: hero.account_id,

      priority: 1.0,

      source_insight_id: hero.source_insight_id,

      source_insight_type: "account",

      source_contact_id: null,

      prompt_id: hero.prompt_id,

      suggested_at: at,

      suggested_date: suggestedDate,

      channel: "email",

      metadata: {

        to_contact_id: hero.to_contact_id,

        sequence_position: hero.sequence_position,

        series_id: hero.series_id,

        series_kind: "SEQUENCE",

      },

    },

    {

      action_id: "K5jJJupVe8j2U50p",

      action_type: CANDIDATE_ACTION_TYPE.INSIGHT_EMAIL,

      account_id: "9cd3eac8-83a3-4372-8a8d-81a3c309bd80",

      priority: 1.0,

      source_insight_id: 164421,

      source_insight_type: "account",

      source_contact_id: null,

      prompt_id: 381326,

      suggested_at: at,

      suggested_date: suggestedDate,

      channel: "email",

      metadata: {

        to_contact_id: 54048,

        sequence_position: 2,

        series_id: "02b9f7af-7a03-47a2-bb7e-d7acae598f1f",

        series_kind: "SEQUENCE",

      },

    },

    {

      action_id: "7LUQoX0h5fFqRsYo",

      action_type: CANDIDATE_ACTION_TYPE.INSIGHT_CALL,

      account_id: "7be4dc50-c22c-47ba-9928-1b6f95579473",

      priority: 0.85,

      source_insight_id: 174216,

      source_insight_type: "account",

      source_contact_id: null,

      prompt_id: 390816,

      suggested_at: at,

      suggested_date: suggestedDate,

      channel: "call",

      metadata: {

        sequence_position: 2,

        series_id: "170295a0-cf6d-4d8e-a13c-bb373ac3326f",

        series_kind: "SEQUENCE",

      },

    },

  ];

}



export function buildTutorialDemoAccounts(clientId: string): IAccountCondensed[] {

  const now = new Date("2026-07-09T12:00:00.000Z");

  return TUTORIAL_DEMO_PORTFOLIO.map((account) => ({

    id: account.id,

    domain: account.domain.startsWith("http")

      ? account.domain

      : `https://${account.domain}`,

    name: account.name,

    client_id: clientId,

    description: null,

    logo_image_url: account.logo_image_url,

    creation_time: now,

    last_update: now,

    latest_insight_published_date: now,

    industry: account.industry,

    primary_user: null,

    secondary_users: [],

    num_account_insights: account.num_account_insights,

    num_contacts: account.num_contacts,

    num_actions: account.num_actions,

    managed_by: null,

  }));

}



export function tutorialDemoAccountsById(): Record<string, IAccountEnrichment> {

  const map: Record<string, IAccountEnrichment> = {};

  for (const account of TUTORIAL_DEMO_ACCOUNT_ENRICHMENTS) {

    map[account.id] = account;

  }

  return map;

}



/** Display label for tour banners (primary account name). */

export { TUTORIAL_SCENARIO };


